// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1GzUw","label":"Completed_label__2s0KW"};